import { Typography } from "antd";
import { renderInlineMarkdown } from "./inlineMd";

const { Paragraph } = Typography;

interface ParagraphBlockProps {
	text: string;
}

export default function ParagraphBlock({ text }: ParagraphBlockProps) {
	return <Paragraph style={{ marginBottom: 12 }}>{renderInlineMarkdown(text)}</Paragraph>;
}
